(function (app, ng) {

    app.config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state("Transaction.Application.InforceApplication",
        {
            url: "/InforceApplication",
            component: "inforceApplication",
            resolve: {
                applicationDocuments: ["transactionDocumentApi", "$stateParams", function (transactionDocumentApi, $stateParams) {
                    return transactionDocumentApi.getTransactionDocumentsByType($stateParams.transactionId, "ApplicationDocument");
                }]
            },
            onEnter: ["transaction", "transactionApi", function(transaction, transactionApi) {
                transaction.LastTransactionStage = "Inforce";
                transactionApi.updateLastTransactionStage(transaction.Id, transaction);
            }]
        });
    }]);

    app.component("inforceApplication",
    {
        templateUrl: "/App/Transaction/Application/InforceApplication/template.html",
        controller: inforceApplicationController,
        bindings: {
            transaction: "<",
            applicationDocuments: "<"
        }
    });

    inforceApplicationController.$inject = ["$state", "$scope", "Upload", "transactionApi", "_", "transactionDocumentApi", "$mdDialog"];
    function inforceApplicationController($state, $scope, Upload, transactionApi, _, transactionDocumentApi, $mdDialog) {
        var $ctrl = this;
        $scope.$parent.$ctrl.getCurrentStage($state);
        $ctrl.prevStage = "Transaction.Determine.Inforce";
        $ctrl.ui = {
            Saving: []
        }

        ng.extend($ctrl,
        {
            uploadFiles: uploadFiles,
            uploadFunc: uploadFunc,
            sortedApplicationDocuments: [],
            name: name,
            submitApp: submitApp,
            skipUpload: skipUpload,
            goBack: goBack,
            removeDocument : removeDocument
            });

        function goBack() {
                if ($ctrl.transaction.DeterminePoints.includes("DetermineDocuments"))
                    $state.go("Transaction.Determine.Documents", { transactionId: $ctrl.transaction.Id });
                else
                    $state.go("Transaction.Determine.Inforce", { transactionId: $ctrl.transaction.Id });
        }

        function uploadFunc(file, index) {
            if (file !== null) {
                var fileName = removeExtension(file.name);
                var payload = new FormData();

                if ($ctrl.sortedApplicationDocuments.indexOf(fileName) === -1) {
                    payload.append("additionalDocument", file, file.name);
                    return transactionDocumentApi.addAdditionalDocument($ctrl.transaction.Id, payload, "ApplicationDocument")
                        .then(function (response) {
                            response.FileName = fileName;
                            $ctrl.applicationDocuments.push(response);
                            $ctrl.ui.Saving[index] = false;
                            if ($ctrl.sortedApplicationDocuments.indexOf(response.FileName) === -1)
                                addNewDoc(response);
                        });
                }
            }
        }


        function uploadFiles(files, index) {
            if (files && files.length) {
                for (var i = 0; i < files.length; i++) {
                    uploadFunc(files[i], index);
                }
            } else {
                uploadFunc(files, index);
            }
        }

        function removeExtension(fileName) {
            fileName = fileName.replace(/\.[^/.]+$/, "");
            return fileName;
        }

        function addNewDoc(response) {
            $ctrl.sortedApplicationDocuments.push(response);
            $ctrl.files.push(response.FileName);
        }

        function removeDocument(index, $event) {
            var confirm = $mdDialog.confirm({
                title: "Are you sure you want to delete this document?",
                targetEvent: $event,
                ariaLabel: "Delete application document",
                ok: "Yes",
                cancel: "No",
                skipHide: true,
                clickOutsideToClose: false
            });
            $mdDialog.show(confirm).then(function () {
                var doc = $ctrl.sortedApplicationDocuments[index];
                var fileIndex = $ctrl.files.indexOf(doc.FileName);
                var docIndex = $ctrl.applicationDocuments.indexOf(doc.FileName);

                return transactionDocumentApi.deleteDocument($ctrl.transaction.Id, doc.Id).then(function () {
                    $ctrl.sortedApplicationDocuments.splice(index, 1);
                    $ctrl.files.splice(fileIndex, 1);
                    $ctrl.applicationDocuments.splice(docIndex, 1);
                });
            });
        };

        function submit() {
            //Logic to submit application needed

            updateStatus("UploadApplication");
        }

        function updateStatus(status) {
            $ctrl.transaction.TransactionStatus = status;
            return transactionApi.updateTransactionStatus($ctrl.transaction.Id, $ctrl.transaction).then(function () {
                return transactionApi.updateTransactionAppStatus($ctrl.transaction.Id, $ctrl.transaction).then(function () {
                    $ctrl.ui.generating = false;
                    $state.go("Home.ViewTransactions");
                });
            });
        }

        function submitApp($event) {
            var leave = $mdDialog.confirm({
                title: "Are you sure you would like to exit this transaction?",
                htmlContent: "<p>If you choose to continue, your transaction will be compiled and added to your transaction list.</p> <p> Any edits to this transaction in the future will be unavailable.</p>",
                targetEvent: $event,
                ariaLabel: "Confirm exiting transaction",
                ok: "Continue",
                cancel: "Cancel",
                skipHide: true,
                clickOutsideToClose: false
            });
            $mdDialog.show(leave)
                .then(function () {
                    $ctrl.ui.generating = true;
                    submit();
                });
        }

        function skipUpload($event) {
            var leave = $mdDialog.confirm({
                title: "Are you sure you would like to skip uploading to iComply?  This cannot be undone.",
                targetEvent: $event,
                ariaLabel: "Confirm skipping upload",
                ok: "Continue",
                cancel: "Cancel",
                skipHide: true,
                clickOutsideToClose: false
            });
            $mdDialog.show(leave)
                .then(function () {
                    $ctrl.ui.generating = true;
                    $ctrl.transaction.TransactionStatus = "Inforce";
                    return transactionApi.updateTransactionStatus($ctrl.transaction.Id, $ctrl.transaction)
                        .then(function () {
                            $ctrl.ui.generating = false;
                            $state
                                .go("Transaction.Application.Terminate", { transactionId: $ctrl.transaction.Id });
                        }, function () {
                            $ctrl.ui.generating = false;
                        });
                });
        }

        this.$onInit = function() {
            $ctrl.transactionGroupName = $scope.$parent.$resolve.transactionGroup.Name;

            $ctrl.files = [];

            if ($ctrl.applicationDocuments.length) {
                ng.forEach($ctrl.applicationDocuments, function (file) {
                    file.FileName = removeExtension(file.FileName);
                    addNewDoc(file);
                });
            };
        };
    }

})(window.app, window.angular);